import React, { useEffect, useState } from "react";
import FlashcardGame from "../componenets/game";
import { Layout } from "antd";
import { useLocation, useParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

const CardGame = () => {
  const { id } = useParams();
  const location = useLocation();
  const [gameData, setGameData] = useState(null);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchGameData = async () => {
      const gameDocRef = doc(db, "users", userId, "cardGames", id);
      const gameDoc = await getDoc(gameDocRef);

      if (gameDoc.exists()) {
        setGameData(gameDoc.data());
      } else {
        console.log("No such document!");
      }
    };

    const customWords = location.state?.customWords;
    if (customWords) {
      setGameData({ words: customWords });
    } else {
      fetchGameData();
    }
  }, []);

  if (!gameData) {
    return (
      <div className="flex justify-center items-center mt-[100px] text-xl text-bold text-gray-400">
        데이터가 없습니다!
      </div>
    );
  }

  return (
    <Layout className="w-full max-w-[1200px] mx-auto bg-white">
      <FlashcardGame 
        selectedWordIds={gameData?.selectedWordIds} 
        customWords={gameData?.customWords} 
        gameId={id}
      />
    </Layout>
  );
};

export default CardGame;
